import { CommonModule } from "@angular/common";
import { Component, Inject, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { mappingOverviewComponentData } from "../../../core/dummy/dummy-data";
import { mappingOverviewComponentTable } from "../../../core/table-templates/mapping-overview-component-table";
import { MappingViewComponent } from "../../modal-templates/mapping-view/mapping-view.component";
import { SharedComponents } from "../../shared.module";

/**
 * The `MappingOverviewComponent` handles the display of mappings, including paginated table data
 * with support for handling actions like opening a dialog for more details. It uses Angular Material Dialog
 * and NgbModal for modal-based actions and views.
 */
@Component({
  selector: "app-mapping-overview",
  standalone: true,
  imports: [SharedComponents, CommonModule, FormsModule],
  templateUrl: "./mapping-overview.component.html",
  styleUrl: "./mapping-overview.component.scss",
})
export class MappingOverviewComponent {
  pageSize: number = 10;
  isPagination: boolean = true;
  private modalService = inject(NgbModal);

  constructor(
    @Inject("STEP_DATA") public data: any,
    public dialog: MatDialog
  ) {}

  tableData = {
    tableHeader: "Total no of Mappings: ",
    data: mappingOverviewComponentData,
    columns: mappingOverviewComponentTable,
  };

  /**
   * Handles table actions based on the event type. If the event type is "icon", it opens the mapping dialog.
   * @param event - The event that triggers the table action, containing the event type and other relevant data.
   */
  handleTableActions(event: any) {
    if (event.type != undefined && event.type == "icon") {
      this.openMappingDialog();
    }
  }

  /**
   * Opens the mapping dialog to view detailed information about the selected mapping.
   * It uses Angular Material's dialog service (`MatDialog`) to open the dialog component.
   */
  openMappingDialog(): void {
    this.dialog.open(MappingViewComponent, {
      // width: '100%',
      // height: '80vh',
      // maxWidth: '90%',
    });
  }
}
